if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.contents = [];
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.contents = Array.from(this.querySelectorAll('[data-content]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.showTab(index);
        });
      });

      this.showTab(0); // Open the first tab by default
    }

    showTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
      });

      this.contents.forEach((content, i) => {
        content.classList.toggle('active', i === index);
      });
    }
  }
  customElements.define('tabs-component', TabsComponent);
}
